import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export const useVhcRecordsAuthorizationEmailMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.postVhcRecordsAuthorizationEmail>>,
      QueryError,
      number,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    (id: number) => {
      return VhcRecordLogService.postVhcRecordsAuthorizationEmail(id);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successful sending!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
